import { render, staticRenderFns } from "./ServiceProviderOverview.vue?vue&type=template&id=9a99b18e&scoped=true"
import script from "./ServiceProviderOverview.vue?vue&type=script&lang=js"
export * from "./ServiceProviderOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a99b18e",
  null
  
)

export default component.exports